import { defineStore } from 'pinia';
import { computed, ref, watch } from 'vue';
import { usePackageStore } from './packageStore';

const widthKey = 'package-details-drawer-width';
const minWidth = 320;
const maxWidth = () => window.innerWidth * 0.4;

/** Selection and layout state of the read-only package details drawer shown over the map. */
export const usePackageDetailsStore = defineStore('package-details', () => {
  const packageStore = usePackageStore();

  const packageId = ref<string | null>(null);
  const isOpen = computed(() => packageId.value !== null);

  function open(id: string) {
    packageId.value = id;
  }

  function close() {
    packageId.value = null;
  }

  function clampWidth(value: number): number {
    return Math.min(Math.max(value, minWidth), maxWidth());
  }

  const width = ref(clampWidth(Number(localStorage.getItem(widthKey)) || 420));
  const resizing = ref(false);

  watch(width, () => {
    localStorage.setItem(widthKey, String(Math.round(width.value)));
  });

  packageStore.changed.on(() => {
    if (packageId.value && !packageStore.getById(packageId.value)) close();
  });

  return {
    packageId,
    isOpen,
    open,
    close,
    width,
    resizing,
    clampWidth,
  };
});
